const theme = {
    maxWidth:"1300px",
    wrapperWidth:"900px",
   
    //color https://coolors.co/101522-1c2237-4b59f7-0467fb-a9b3c1-f7f8fa
    primary: "#101522",
    second: "#1c2237",
    tertiary: "#4b59F7",
    quaternary:"#0467FB", //CTA
    quinary: "#a9b3c1",
    senary: "#f7f8FA",
    //font
    firstFont: `'Roboto', sans-serif`,  
    secondFont:`'Montserrat',sans-serif;`,
}

export default theme